<template>
  <div>
      <CCol col="12" sm="6" lg="3">
        <CWidgetIcon
          :header=numberOfUsers
          text="Users on platform"
          color="gradient-info"
        >
          <CIcon name="cil-laptop" width="24"/>
        </CWidgetIcon>

      </CCol>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {

  data() {
    return {
      users: {}
    };
  },
  async mounted() {
    await this.getUsers();
  },
  methods: {
    ...mapActions(["listUsers"]),
    login() {
      // this.$auth.loginWithRedirect();
    },
    async getUsers() {
      this.users = await this.listUsers({include_totals:true});
    }
  },
  computed: {
    numberOfUsers () {
      if (this.users.length) {
       return this.users.total.toString() 
      }
       return "Fetching..."
    }
  }
};
</script>

<style scoped>
.myIframe {
     min-width: 600px;
     position: relative;
     padding-bottom: 65.25%;
     padding-top: 30px;
     height: 0;
     overflow: auto; 
     -webkit-overflow-scrolling:touch;
     border: solid black 1px;
} 
.myIframe iframe {
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
}
</style>
